import { getCrudAdImagePreviewStyles, getMMAPreviewStyles } from '@bingads-webui-campaign-react/shared-image-preview-styles';

import { floatButtonStyle, underlineLinkStyle, reactUIBlockerStyle } from './shared-styles-from-theme-fluent';
import { getLocalBlockerStyle } from './local-blocker';
import { getPhoneFrameStyle } from './phone-frame-style';
import { truncatedStyle } from './truncated-style';
import { uurlTestToolStyle } from './uurl-test-tool-style';
import { modalContainerStyle } from './modal-container-style';
import BingSearchImage from '../media/BingSearch.png';
import type { CommonStylesPalette } from '../types.d';


export const crudRSAStyle = ({ palette = {} as CommonStylesPalette, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '& .headlines-container, & .descriptions-container': {
    marginTop: 32,

    '& .form-group ~ .form-group': {
      marginTop: 12,
    },

    '& .form-group + .col-sm-4.control-label': {
      display: 'none',
    },

    '& a.ad-rsa-add-headline, & a.ad-rsa-add-description': {
      fontSize: 14,
      lineHeight: '19px',
      marginTop: 12,
      textAlign: 'left',

      '&.disabled': {
        color: palette.neutralTertiary,
      },
    },

    '& .ad-rsa-filed-group': {
      display: 'grid',
      fallbacks: [
        {
          display: '-ms-grid',
        },
      ],
      gridTemplateColumns: '1fr auto',
      '-ms-grid-columns': '1fr auto',

      '& .iconba-Lightbulb': {
        position: 'absolute',
        left: '-18px',
        top: '9.5px',
        color: '#0078d4',
        visibility: 'hidden',
      },

      '& > input.text': {
        gridColumnStart: '1',
        '-ms-grid-column': '1',
        '-ms-grid-row': '1',
      },

      '& > .clearfix': {
        gridColumnStart: '1',
        '-ms-grid-column': '1',
        '-ms-grid-row': '2',
      },

      '& > ul': {
        gridColumnStart: '1',
        '-ms-grid-column': '1',
        '-ms-grid-row': '3',
      },

      '& > .ad-rsa-pin-group': {
        gridColumnStart: '2',
        '-ms-grid-column': '2',
        '-ms-grid-row': '1',
        minWidth: 56,
        paddingTop: 6,
        position: 'relative',
        right: 'auto',
        top: 'auto',

        '& .ad-field-position': {
          color: palette.neutralPrimary,
          fontSize: 14,
          lineHeight: '19px',
          visibility: 'visible !important',
        },

        '& .ad-pinned': {
          fontSize: 14,
          width: 'fit-content',
        },
      },
    },

    '& .glyphicon-pushpin, & .glyphicon-plus': {
      color: palette.themePrimary,
      fontFamily: iconFontFamily,
    },

    '& .glyphicon-pushpin:before': {
      content: '"\\E840"',
      padding: '0 8px 0 12px',
    },

    '& .glyphicon-plus:before': {
      content: '"\\E710"',
      marginRight: 8,
    },
  },

  '& .ad-strength-container': {
    borderRadius: 2,
    boxShadow: '0px 0.3px 0.9px rgba(0, 0, 0, 0.108), 0px 1.6px 3.6px rgba(0, 0, 0, 0.132)',
    marginBottom: 12,
    width: 592,
    padding: '15px 20px',

    '& .responsive-search-ad-strength-view': {
      '& label': {
        fontSize: 18,
        fontWeight: 'normal',
        lineHeight: '24px',
        padding: 0,
      },

      '& a.helpbutton::before': {
        top: '-1px !important',
      },

      '& .ad-strength-content': {
        display: 'inline-flex',
        marginTop: 15,
      },

      '& .ad-strength-score': {
        margin: '-10px 16px 0 -20px',
      },

      '& .ad-strength-suggestions': {
        fontSize: 14,
        lineHeight: '20px',
      },

      '& .ad-strength-suggestion-view': {
        color: '#1570A6',
        cursor: 'pointer',
        display: 'inline-block',
        marginLeft: '10px',
        '&:focus': {
          outline: 'thin dotted',
        },
      },

      '& .responsive-search-ad-strength-suggestion-title': {
        paddingLeft: 30,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      },

      '& .iconba-Lightbulb': {
        color: '#0078d4',
        position: 'absolute',
        top: 21,
      },

      '& .ad-strength-suggestion-detail-nosuggestion-container-legacy': {
        borderTop: '1px solid #EDEBE9',
        marginTop: 12,
        paddingTop: 24,
      },

      '& .ad-strength-suggestions-detail': {
        display: 'none',
        position: 'absolute',
        left: 0,
        top: 217,
        zIndex: 1,
        border: 'solid 1px #dddddd',
        boxShadow: '0px 0.3px 0.9px rgba(0, 0, 0, 0.108), 0px 1.6px 3.6px rgba(0, 0, 0, 0.132)',
        background: '#fff',
        padding: '16px 24px',
        width: 592,
        minHeight: 250,
      },

      '& .ad-strength-suggestions-detail-close-button': {
        color: '#333333',
        cursor: 'pointer',
        float: 'right',
        position: 'relative',
        verticalAlign: 'middle',
      },

      '& .ad-strength-suggestion-detail-title': {
        color: '#333333',
        fontFamily: 'Segoe UI',
        fontSize: 14,
        fontWeight: 'bold',
        marginTop: 0,
        marginBottom: 4,
      },

      '& .ad-strength-suggestion-detail-sub-title': {
        color: '#333333',
        fontFamily: 'Arial',
        fontSize: 12,
        fontWeight: 'normal',
        marginBottom: 12,
      },

      '& .ad-strength-suggestion-detail-no-suggestion': {
        marginTop: 12,
        marginBottom: 12,
      },

      '& .ad-strength-suggestion-detail-tips-container': {
        marginBottom: 25,
      },

      '& .ad-strength-suggestion-detail-tips-title': {
        color: '#333333',
        cursor: 'pointer',
        fontFamily: 'Arial',
        fontSize: 12,
        fontWeight: 'normal',
        '&:focus': {
          outline: 'thin dotted',
        },
      },

      '& .ad-strength-suggestion-detail-tips-subtitle': {
        color: '#333333',
        fontFamily: 'Arial',
        fontSize: 12,
        fontWeight: 'normal',
        marginBottom: 5,
      },

      '& .ad-strength-suggestion-detail-tips-item-container': {
        color: '#333333',
        display: 'none',
        fontFamily: 'Arial',
        fontSize: 12,
        fontWeight: 'normal',
        marginLeft: 16,
        marginBottom: 10,
      },

      '& .ad-strength-suggestion-detail-tips-header': {
        fontWeight: 'bold',
        marginTop: 8,
        marginBottom: 4,
      },

      '& .ad-strength-suggestion-detail-tips-header-desc': {
        marginBottom: 4,
      },

      '& .ad-strength-suggestion-detail-tips-category-title': {
        display: 'inline-block',
        marginBottom: 4,
        marginLeft: 4,
      },

      '& .ad-strength-suggestion-detail-tips-item': {
        '&:before': {
          content: '"\\2022"',
          padding: '5px 5px',
        },
        marginBottom: 5,
      },

      '& .ad-strength-suggestions-llm-loading-process': {
        marginTop: 12,
      },

      '& .ad-strength-suggestion-detail-suggestions-container': {
        marginTop: 15,
      },

      '& .ad-strength-suggestion-detail-suggestions-container-llm': {
        marginTop: 12,
        borderTop: '1px solid #EDEBE9',
        '& .ad-strength-suggestion-detail-suggestion, & .ad-strength-suggestion-detail-suggestion-disabled': {
          marginBottom: '0px !important',
        },
      },

      '& .ad-strength-suggestion-detail-suggestions-container-legacy': {
        marginTop: 15,
        paddingTop: 20,
        borderTop: '1px solid #EDEBE9',
      },

      '& .ad-strength-suggestion-detail-nosuggestion-llm-default': {
        marginTop: 24,
        pointerEvents: 'none',
        '-webkit-mask-image': 'linear-gradient(to bottom, rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0))',
      },

      '& .ad-strength-suggestion-llm-detail-llm-perspective': {
        paddingTop: 20,
        marginBottom: 28,
        borderTop: '1px solid #EDEBE9',
      },

      '& .ad-strength-suggestion-detail-llm-perspective-title': {
        marginBottom: 4,
        fontWeight: 600,
      },

      '& .ad-strength-suggestion-detail-llm-perspective-pitching-point': {
        marginBottom: 12,
      },

      '& .ad-strength-suggestion-detail-suggestion': {
        '&:hover': {
          backgroundColor: '#106ebe',
          borderColor: '#106ebe',
          color: '#ffffff',
        },
        '&:active': {
          backgroundColor: '#106ebe',
          borderColor: '#106ebe',
          color: '#ffffff',
        },
        '&:disabled': {
          backgroundColor: '#f3f2f1',
          borderColor: '#f3f2f1',
          color: '#a19f9d',
        },
        display: 'inline-block',
        backgroundColor: '#ffffff',
        color: '#106ebe',
        cursor: 'pointer',
        borderColor: '#106ebe',
        borderWidth: 1,
        borderStyle: 'solid',
        marginBottom: 8,
        marginRight: 8,
        fontSize: 14,
        padding: '0px 4px 0px 4px',
        textAlign: 'left',
        borderRadius: 2,
      },

      '& .ad-strength-suggestion-detail-suggestion-disabled': {
        display: 'inline-block',
        color: '#a19f9d',
        backgroundColor: '#f3f2f1',
        borderWidth: 1,
        borderStyle: 'solid',
        marginBottom: 8,
        marginRight: 8,
        fontSize: 14,
        borderRadius: 2,
        padding: '0px 4px 0px 4px',
        textAlign: 'left',
        cursor: 'default',
      },

      '& .ad-strength-suggestion-detail-suggestion-add-symbol': {
        display: 'table-cell',
        fontSize: 20,
        padding: '0px 10px 2px 0px',
        verticalAlign: 'middle',
      },

      '& .ad-strength-suggestion-detail-suggestion-id': {
        display: 'none',
      },

      '& .ad-strength-suggestion-detail-suggestion-content': {
        display: 'table-cell',
        padding: '0px 4px 0px 0px',
        verticalAlign: 'middle',
      },

      '& .ad-strength-suggestion-detail-no-new-asset-container': {
        marginBottom: 15,
      },

      '& .ad-strength-suggestion-detail-warning': {
        marginRight: 5,
      },

      '& .ad-strength-suggestion-detail-add-all-button': {
        display: 'inline-block',
        textDecoration: 'underline',
        color: '#106ebe',
      },

      '& .ad-strength-suggestion-detail-add-all-button-disabled': {
        display: 'inline-block',
        textDecoration: 'underline',
        cursor: 'default',
        color: '#a19f9d',
      },

      '& ul.ad-strength-actions': {
        '& li': {
          padding: '2px 0',

          '& .ad-strength-action-met, & .ad-strength-action-half-met, & .ad-strength-action-not-met': {
            fontFamily: iconFontFamily,
            fontSize: 16,
            lineHeight: '20px',
            marginRight: 8,
            verticalAlign: 'middle',
          },

          '& .ad-strength-action-met': {
            color: '#107C10',

            '&:before': {
              content: '"\\EC61"',
            },
          },

          '& .ad-strength-action-half-met': {
            color: '#FFB900',

            '&:before': {
              content: '"\\EC61"',
            },
          },

          '& .ad-strength-action-not-met': {
            color: palette.neutralSecondary,

            '&:before': {
              content: '"\\ECCA"',
            },
          },
        },
      },
    },
  },

  '& .ad-strength-suggestion-picker-title': {
    fontWeight: 'bold',
  },
  '& .rsa-left-column, & .ad-customizer-container': {
    '& input.ms-TextField-field': {
      '&:hover': {
        border: 'none',
      },
      '&:focus': {
        border: 'none',
      },
    },
    '& .ms-TextField-fieldGroup': {
      '&:after': {
        display: 'none',
      },
    },
    '& .ms-Dropdown': {
      '&:after': {
        borderWidth: '1px',
      },
    },
    '& .llm-quota-metric': {
      float: 'right',
    },
    '& .llm-quota-metric-circle-green': {
      width: 10,
      height: 10,
      marginLeft: 10,
      backgroundColor: '#107C10',
      display: 'inline-block',
      borderRadius: 20,
    },
    '& .llm-quota-metric-circle-orange': {
      width: 10,
      height: 10,
      marginLeft: 10,
      backgroundColor: '#FFB729',
      display: 'inline-block',
      borderRadius: 20,
    },
    '& .llm-quota-metric-circle-red': {
      width: 10,
      height: 10,
      marginLeft: 10,
      backgroundColor: '#D83B01',
      display: 'inline-block',
      borderRadius: 20,
    },
  },
});

const crudAppInstallAdStyle = ({ palette = {} as CommonStylesPalette, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '& .app-lookup-control': {
    '& .applookup-dropdown': {
      '& .col-sm-8': {
        width: '100%',
      },

      '& .col-sm-offset-4': {
        marginRight: 0,
      },

      '& .form-control.changeapp': {
        paddingRight: 32,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },

      '& .dropDownSelect': {
        '& .icon.change-app-edit': {
          color: palette.neutralSecondary,
          fontFamily: iconFontFamily,
          position: 'absolute',
          top: 8,
          right: 8,
          margin: 0,

          '&:before': {
            content: '"\\E70D"',
          },
        },

        '& .appinfo-table': {
          border: `1px solid ${palette.neutralSecondary}`,

          '& .app-icon': {
            width: 58,
          },

          '& .app-details': {
            width: 'auto',

            '& .appstoreselector, & span': {
              fontSize: 12,
              lineHeight: '16px',
              '&[data-bind="text: DeveloperName"]': {
                color: palette.neutralSecondary,
              },
            },
          },

          '& .app-actions': {
            width: 24,

            '& .icon.changeapp': {
              color: palette.themeDark,
              fontFamily: iconFontFamily,
              position: 'absolute',
              top: 8,
              right: 8,
              margin: 0,

              '&:before': {
                content: '"\\E70F"',
              },
            },
          },
        },
      },

      '& > .popover': {
        left: '0 !important',
        top: '32px !important',
        maxWidth: '100%',
        width: 467,

        '& .popover-content': {
          fontSize: 14,
          lineHeight: '19px',
          padding: '12px 32px 30px 32px',

          '& .applookup': {
            width: 'unset',

            '& > .form-group': {
              marginTop: 16,
            },

            '& .searchbox': {
              '& .searchbox-input': {
                padding: '6px 8px 6px 32px',
              },

              '& .form-control-feedback': {
                left: 0,
                right: 'unset',
                lineHeight: '32px',
                height: 32,
                width: 32,
                pointerEvents: 'auto',

                '& .searchbox-searchbutton': {
                  fontFamily: iconFontFamily,
                  fontSize: 16,
                  lineHeight: 1,
                  padding: 8,

                  '&:before': {
                    content: '"\\E721"',
                  },
                },
              },
            },
          },

          '& table.action-radio': {
            '& tr > *': {
              display: 'block',
            },

            '& tr': {
              display: 'table-cell',
            },

            '& td ~ td': {
              marginTop: 12,
            },

            '& .radio': {
              minHeight: 'unset',
            },
          },

          '& .scrollable-appresult': {
            border: `1px solid ${palette.neutralLighter}`,
            margin: '16px 0 12px 0',
            maxHeight: 290,

            '& .applookup-results-row': {
              border: `1px solid ${palette.neutralLighter}`,
              height: 48,

              '& .app-icon': {
                width: 48,

                '& img': {
                  margin: 0,
                },
              },

              '& .app-result-details': {
                paddingLeft: 8,
                maxWidth: 0,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                width: 'auto',
              },

              '& .appstoreselector, & span': {
                fontSize: 12,
                lineHeight: '16px',
              },

              '& span[data-bind="text: DeveloperName"]': {
                color: palette.neutralSecondary,
              },
            },
          },
        },
      },
    },

    '& .blocker-local': {
      extend: getLocalBlockerStyle(palette)['.blocker-local'],
    },
  },

  '& .app-upgraded-url': {
    marginTop: 32,

    '& .fieldRowAd > .form-group': {
      marginTop: 0,
    },

    '& #landingPageLabel > div': {
      display: 'none',
    },
  },

  '& .app-install__mobile-frame, & .app-install__tablet-frame': {
    ...getPhoneFrameStyle(palette).outerFrame,
  },

  '& .app-install__mobile-frame': {
    width: 527,
  },

  '& .app-install__tablet-frame': {
    width: 720,
  },

  '& .app-install__preview-ad': {
    ...getPhoneFrameStyle(palette).innerFrame,

    padding: '30px 32px 0 32px',

    '& .app-install__preview': {
      display: 'flex',
      marginBottom: 8,

      '& .preview-app-icon, & .preview-app-image, & .preview-app-placeholder': {
        height: 80,
        width: 80,
        marginRight: 9,
      },
      '& .preview-app-description': {
        width: 'calc(100% - 89px)',

        '& .preview-app-title': {
          color: '#0E3EB5',
          fontSize: 18,
          fontWeight: 600,
          lineHeight: '24px',
        },

        '& .preview-app-details': {
          color: '#767676',
          fontSize: 14,
          lineHeight: '20px',
          paddingTop: 4,
          wordWrap: 'break-word',
          wordBreak: 'break-word',
        },
      },
    },

    '& .app-install__actions': {
      display: 'flex',
      justifyContent: 'space-between',

      '& .preview-app-url': {
        color: '#646464',
        fontSize: 11,
        fontWeight: 600,
        lineHeight: '24px',
        padding: '2px 0',
        verticalAlign: 'baseline',

        '&:before': {
          border: '1px solid #ddd',
          borderRadius: 6,
          content: '"Ad"',
          lineHeight: 1,
          marginRight: 5,
          padding: '0 2px',
        },

        '&:after': {
          color: '#575757',
          content: '"\\F08E"',
          fontFamily: iconFontFamily,
          marginLeft: 5,
        },
      },

      '& .btn-default': {
        color: '#111111',
        fontSize: 14,
        lineHeight: '24px',

        '&:before': {
          content: '"\\E896"',
          fontFamily: iconFontFamily,
          marginRight: 10,
        },
      },
    },
  },
});

const experienceContent = ({ palette = {} as CommonStylesPalette, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '& .image-experience-content': {
    marginBottom: 10,
    minWidth: 669,

    '& .image-list-view-content .image-list': {
      position: 'relative',
      marginBottom: 0,

      '& .image-list-content': {
        width: '100%',
        overflowX: 'auto',

        '&:after': {
          content: '""',
          display: 'inline-flex',
          flexBasis: 28,
          flexShrink: 0,
        },

        '& .image-list-item .image-list-item-image, & .image-list-item .image-list-item-video': {
          '& .glyphicon.glyphicon-remove.image-delete': {
            extend: floatButtonStyle({ palette }).floatButton,
            fontFamily: iconFontFamily,
            fontSize: 16,
            lineHeight: 1,
            margin: 0,
            padding: 8,
            position: 'absolute',
            left: 'auto',
            top: 'auto',
            right: 2,
            bottom: 2,
            borderRadius: '50%',
            marginBottom: 8,
            marginRight: 20,

            '&:before': {
              content: '"\\E711"',
            },
          },

          '& .glyphicon.glyphicon-pencil.image-edit': {
            extend: floatButtonStyle({ palette }).floatButton,
            fontFamily: iconFontFamily,
            lineHeight: 1,
            fontSize: 16,
            border: 'none',
            position: 'absolute',
            left: 2,
            top: 'auto',
            right: 'auto',
            bottom: 2,
            backgroundColor: `${palette.white}d4`,
            borderRadius: '50%',
            marginLeft: 20,
            marginBottom: 8,
            height: 32,
            width: 32,
            padding: 0,

            '&:before': {
              content: '"\\E70F"',
            },

            '&:hover': {
              backgroundColor: `${palette.themeDarkAlt}ff`,
              '&:before': {
                color: palette.white,
              },
            },
          },

          '& .glyphicon.glyphicon-pencil.image-edit.is-recommended-image': {
            opacity: 0.5,
          },

          '& .image-edit + .glyphicon.glyphicon-remove.image-delete': {
            extend: floatButtonStyle({ palette }).floatButton,
            fontFamily: iconFontFamily,
            lineHeight: 1,
            fontSize: 16,
            border: 'none',
            position: 'absolute',
            left: 'auto',
            top: 'auto',
            right: 2,
            bottom: 2,
            backgroundColor: `${palette.white}d4`,
            borderRadius: '50%',
            marginRight: 20,
            marginBottom: 8,
            height: 32,
            width: 32,
            padding: 0,

            '&:before': {
              content: '"\\E711"',
            },

            '&:hover': {
              backgroundColor: `${palette.themeDarkAlt}ff`,
              '&:before': {
                color: palette.white,
              },
            },
          },

          '& .iconba.iconba-Lightbulb': {
            color: palette.accent,
            top: 2,
            borderBottomRightRadius: '100%',
            paddingTop: 2,
            paddingLeft: 3,
            background: 'rgba(255, 255, 255, 0.9)',
            left: 2,
            width: 21,
            height: 21,
            fontSize: 15,
            position: 'absolute',
          },
          '& .info-overlay': {
            position: 'absolute',
            left: '4px',
            bottom: '4px',
            height: '20px',
            width: '20px',
            backgroundColor: 'rgba(255, 255, 255, 0.733)',
            borderRadius: '4px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',

            '& svg': {
              width: '16px',
              height: '16px',
            },
          },
        },

        '& .image-list-item .image-list-item-image.with-new-editor-icon': {
          '&:hover': {
            '& .image-list-item-action-bar': {
              opacity: 1,
            },
          },
          '& .image-list-item-action-bar': {
            '&.open': {
              opacity: 1,
            },
            opacity: 0,
            position: 'absolute',
            bottom: '6px',
            gap: '6px',
            translate: '-50%',
            left: '50%',
            display: 'flex',
            '& button.image-edit, button.image-delete': {
              border: 'none',
              boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.14), 0px 0px 2px 0px rgba(0, 0, 0, 0.12)',
              backgroundColor: palette.white,
              borderRadius: '4px',
              '&:hover, &:focus': {
                backgroundColor: '#f5f5f5',
              },
            },
            '& button.is-recommended-image': {
              opacity: 0.5,
              backgroundColor: palette.white,
              borderRadius: '4px',
              '&:hover, &:focus': {
                backgroundColor: '#f5f5f5',
              },
            },
          },
        },

        '& .image-list-item .image-list-item-image.with-copilot-option': {
          '&:hover': {
            '& .image-list-item-action-bar': {
              opacity: 1,
            },
          },
          '& .image-list-item-action-bar': {
            '&.open': {
              opacity: 1,
            },
            display: 'flex',
            backgroundColor: palette.white,
            borderRadius: 8,
            opacity: 0,
            position: 'absolute',
            bottom: 6,
            marginLeft: 6,
            padding: [0, 8, 0, 4],
            overflow: 'hidden',

            '& button': {
              minWidth: 24,
              margin: [6, 0, 6, 4],
              width: 24,
              height: 24,
              padding: 0,
              border: 'none',
              backgroundColor: palette.white,
              '& img': {
                width: 24,
                height: 24,
              },
              '& .active': {
                display: 'none',
                backgroundColor: palette.themeDarkAlt,
              },
              '& .passive': {
                display: 'inline-block',
                backgroundColor: palette.white,
              },
              '&:hover, &:focus': {
                '& .active': {
                  display: 'inline-block',
                },
                '& .passive': {
                  display: 'none',
                },
              },
            },
            '& .action-divider': {
              margin: [6, 0, 6, 4],
              width: 1,
              height: 24,
              display: 'inline-block',
              borderLeft: `1px solid ${palette.neutralQuaternaryAlt}`,
            },
            '& .glyphicon.glyphicon-remove.image-delete': {
              position: 'static',
              margin: [6, 0, 6, 4],
              width: 24,
              height: 24,
              extend: floatButtonStyle({ palette }).floatButton,
              fontSize: 16,
              color: palette.neutralPrimary,
              backgroundColor: palette.white,
              padding: 0,
              borderRadius: 'unset',
              opacity: 1,

              '&:before': {
                content: '"\\E74D"',
              },
              '&:hover': {
                backgroundColor: palette.themeDarkAlt,
                '&:before': {
                  color: palette.white,
                },
              },
            },
          },
          '& .glyphicon.glyphicon-pencil.image-edit': {
            position: 'static',
            margin: [6, 0, 6, 4],
            width: 24,
            height: 24,
            borderRadius: 'unset',
            backgroundColor: palette.white,
            '&:before': {
              color: palette.neutralPrimary,
            },
            '&:hover': {
              '&:before': {
                color: palette.white,
              },
              backgroundColor: palette.themeDarkAlt,
            },
            opacity: 1,
          },
        },

        '& .remove-all-button': {
          background: 'white',
          display: 'flex',
          position: 'absolute',
          left: 'auto',
          top: 1,
          right: 1,
          bottom: 20,
          height: 'auto',
          margin: 0,
        },

        '& .image-list-choice-group-ad-creator': {
          '& .ms-ChoiceFieldGroup-flexContainer': {
            '& .ms-ChoiceField': {
              '& .ms-ChoiceField-field': {
                borderWidth: 2,
                height: 95,
                width: 112,
                padding: 0,

                '&:before, &:after': {
                  zIndex: 1,
                },
              },

              '& .ms-ChoiceField-innerField': {
                padding: 0,
                height: 63,
                width: 112,
              },
            },
          },
        },

        '& .image-list-choice-group': {
          '& .ms-Label, & .ms-ChoiceField-labelWrapper': {
            display: 'none',
          },

          '& .ms-ChoiceFieldGroup-flexContainer': {
            display: 'flex',
            flexFlow: 'row',

            '& .ms-ChoiceField': {
              margin: 0,

              '& ~ .ms-ChoiceField': {
                marginLeft: 8,
              },

              '& .ms-ChoiceField-field': {
                borderWidth: 2,
                height: 63,
                width: 112,
                padding: 0,

                '&:before, &:after': {
                  zIndex: 1,
                },
              },

              '& .ms-ChoiceField-innerField': {
                padding: 0,
              },
            },
          },
        },
      },
    },
  },
});


export const crudAdStyle = ({ palette = {} as CommonStylesPalette, iconFontFamily = 'MsAds MDL2 Assets' }) => ({

  '& .form-group': {
    margin: 0,
  },

  '& .form-group:not([style="display: none;"]) ~ .form-group': {
    marginTop: 32,
  },

  '& .ad-editor-form__container': {
    display: 'flex',
    flexDirection: 'column',

    '& > div:not([style="display: none;"]) ~ div': {
      marginTop: 32,
    },

    '& .alert.alert-info.form-group': {
      marginTop: 8,
    },

    '& .warn.warn-info.form-group': {
      padding: 8,
      background: '#FFF4CE',
      marginBottom: '20px',
      fontSize: '12px',

      '& .warn-image': {
        color: '#D83B01',
        fontSize: '16px !important',
        padding: '10px 8px 16px 8px',
        float: 'left',
      },
    },
  },

  '& .form-group > #KoErrors': {
    marginLeft: 0,
    display: 'flex',
    flexDirection: 'column',
  },

  '& .panel-title': {
    fontWeight: 600,
  },

  '& .panel-body-ad': {
    padding: '32px 32px 0 0',
    marginTop: '0 !important',
  },

  '& textarea': {
    height: 69,
    resize: 'none',
  },

  '& ul.ui-tabs-nav': {
    display: 'flex',

    '& > li': {

      '& > a': {
        background: palette.neutralLighter,
        border: '1px solid transparent',
        borderRadius: 0,
        color: palette.neutralPrimary,
        padding: '12px 24px',
        fontSize: 14,
        fontWeight: 'normal',
        height: 40,
        lineHeight: '12px',
        textAlign: 'center',

        '&:hover': {
          background: palette.neutralLight,
        },

        '&:focus': {
          border: '1px solid #605E5C',
        },

        '&.btn.focus:after, &.btn:focus:after': {
          border: 'none',
        },
      },

      '&.ui-tabs-selected > a': {
        background: palette.themeLighterAlt,
        fontWeight: 600,

        '&:hover': {
          background: palette.themeLight,
        },
      },
    },
  },

  '& .preview-container': {
    '& .preview-nav-pills': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'stretch',
      marginBottom: 36,
      width: '100%',
    },

    '& .ad-preview-bing-searchbox-icon': {
      background: `url(${BingSearchImage}) no-repeat -5px -5px`,
      height: 100,
      width: 530,
    },

    '& .previews': {
      '& .previewTitleAd': {
        color: '#001BA0',
        fontSize: 20,
        lineHeight: '24px',
      },

      '& .previewUrlAd': {
        color: '#006D21',
        fontSize: 13,
        lineHeight: '24px',
      },

      '& .preview-ad__description': {
        color: '#767676',
        fontSize: 13,
        lineHeight: '24px',

        '&:before': {
          border: '1px solid #ddd',
          borderRadius: 6,
          content: '"Ad"',
          fontSize: 11,
          fontWeight: 600,
          lineHeight: 1,
          marginRight: 4,
          padding: '0 2px',
        },
      },

      '& .preview-ad-slug': {
        display: 'none',

        '& + span': {
          display: 'none',
        },
      },

      '& .preview-top .bing-preview-answer': {
        padding: '0 0 0 36px',
      },

      '& .preview-sidebar .bing-preview-container': {
        padding: '0 0 0 18px',
      },

      '& .preview-mobile': {
        ...getPhoneFrameStyle(palette).outerFrame,
        width: 527,

        '& .preview-device-Pref': {
          ...getPhoneFrameStyle(palette).innerFrame,

          '& .previewAd.mainline': {
            borderRadius: 2,
            boxShadow: '0px 0.3px 0.9px rgba(0, 0, 0, 0.108), 0px 1.6px 3.6px rgba(0, 0, 0, 0.132)',
            margin: 16,
            padding: '8px 16px',
          },
        },

        '& .previewTitleAd': {
          fontSize: 14,
        },

        '& .previewUrlAd, & .preview-ad__description': {
          fontSize: 12,
        },
      },

      '& a:hover': {
        textDecoration: 'underline',
      },
    },

    ...truncatedStyle,
  },

  '& > div:not([style="display: none;"]) ~ div': {
    marginTop: 32,
  },

  '& .col-sm-1, & .col-sm-2, & .col-sm-3, & .col-sm-4, & .col-sm-5, & .col-sm-6, & .col-sm-7, & .col-sm-8, & .col-sm-9, & .col-sm-10, & .col-sm-11, & .col-sm-12': {
    float: 'none',
    paddingLeft: 0,
    paddingRight: 0,
  },

  '& .col-sm-8': {
    width: '80%',
  },

  '& .col-sm-offset-4': {
    marginLeft: 0,
    marginRight: '20%',
  },

  '& .row': {
    display: 'flex',
    margin: 0,
  },

  '& > .p': {
    marginTop: 32,
  },

  '& .form-group .control-label': {
    display: 'flex',
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '19px',
    padding: '0 0 8px 0',
    textAlign: 'left',
  },

  '& .form-group label': {
    padding: 0,
  },

  '& .form-hint, & .remaining-hint, & .charactersRemaining, & .remaining-chars-hint': {
    color: palette.neutralPrimary,
    fontSize: 14,
    lineHeight: '20px',
    textAlign: 'right',
    marginTop: 4,
    marginBottom: 0,
  },

  '& .checkbox, & .radio': {
    paddingTop: 0,

    '& > label': {
      left: 0,
    },

    '& input[type="checkbox"], & input[type="radio"]': {
      marginLeft: 0,
    },

    '& input[type="checkbox"]': {
      fontFamily: iconFontFamily,
      appearance: 'none',
      '-webkit-appearance': 'none',

      '&:after': {
        content: '"\\E73E"',
      },
    },
  },

  '& .ext-ad-url-options, & .advanced-url-options': {
    '& .row': {
      display: 'block',
    },

    '& .col-sm-offset-4 .row': {
      display: 'table-row',
      fontSize: 14,
      lineHeight: '20px',
      padding: 0,
    },

    '& div[data-bind="visible: isExpanded"]': {
      marginTop: 32,
    },

    '& .form-control-static': {
      padding: '2px 0',
      minHeight: 'unset',
    },

    '& ul#TrackingTemplateErrors li': {
      paddingTop: 4,
    },

    '& .accordion': {
      marginTop: 32,
      paddingBottom: 0,
      whiteSpace: 'nowrap',
    },

    '& .upgraded-url-options-preview__label': {
      color: palette.neutralPrimary,
      display: 'table-cell',
      marginRight: 14,
      padding: '2px 4px 2px 0',
      whiteSpace: 'nowrap',
      verticalAlign: 'top',

      '& span': {
        verticalAlign: 'baseline',
      },
    },

    '& .upgraded-url-options-preview__value': {
      display: 'table-cell',
      padding: '2px 0',
      whiteSpace: 'nowrap',

      '& span': {
        verticalAlign: 'baseline',
      },

      '& .form-inline': {
        display: 'flex',
      },

      '& .control-label': {
        fontWeight: 'normal',
        padding: 0,
      },

      '& .custom-params-template .row .form-inline span:last-of-type': {
        paddingLeft: 4,
      },
    },

    '& .tracking-template': {
      display: 'flex',
    },
  },

  '& .expand-url-options .expanderImage, & .link.expander .expanderImage, & .call-to-action .expanderImage, & .boost-anchors .expanderImage': {
    color: palette.themePrimary,
    fontSize: 14,
    lineHeight: '24px',

    '&:before': {
      fontFamily: iconFontFamily,
      content: '"\\E76C"',
      marginRight: 8,
    },
  },

  '& .expand-url-options .expandedImage, & .link.expanded .expandedImage, & .call-to-action .expandedImage, & .boost-anchors .expandedImage': {
    color: palette.themePrimary,
    fontSize: 14,
    lineHeight: '24px',

    '&:before': {
      fontFamily: iconFontFamily,
      content: '"\\E70D"',
      marginRight: 8,
    },
  },

  '& .tracking-template__container > div': {
    display: 'grid',
    fallbacks: [
      {
        display: '-ms-grid',
      },
    ],
    gridTemplateColumns: '1fr auto',
    '-ms-grid-columns': '1fr auto',

    '& > *': {
      gridColumnStart: '1',
      gridColumnEnd: 'span 2',
      '-ms-grid-column': '1',
      '-ms-grid-column-span': '2',
    },

    '& > span': {
      display: 'block',
    },

    '& > input.tracking-template__value-field': {
      gridColumnStart: '1',
      gridColumnEnd: '1',
      '-ms-grid-column': '1',
      '-ms-grid-column-span': '1',
      '-ms-grid-row': '1',
    },

    '& > .charactersRemaining': {
      '-ms-grid-row': '2',
      textAlign: 'left',
    },

    '& > .font-error': {
      '-ms-grid-row': '4',
    },

    '& > #trackingTemplateErrors': {
      '-ms-grid-row': '5',
    },

    '& > span.control-label': {
      '-ms-grid-row': '6',
    },

    '& > :last-child': {
      '-ms-grid-row': '7',
    },
  },

  '& .final-url-suffix__container > div': {
    display: 'grid',
    fallbacks: [
      {
        display: '-ms-grid',
      },
    ],
    gridTemplateColumns: '1fr auto',
    '-ms-grid-columns': '1fr auto',

    '& > *': {
      gridColumnStart: '1',
      gridColumnEnd: 'span 2',
      '-ms-grid-column': '1',
      '-ms-grid-column-span': '2',
    },

    '& > span': {
      display: 'block',
    },

    '& > input.tracking-template__value-field': {
      gridColumnStart: '1',
      gridColumnEnd: '1',
      '-ms-grid-column': '1',
      '-ms-grid-column-span': '1',
      '-ms-grid-row': '1',
    },

    '& > .charactersRemaining': {
      '-ms-grid-row': '2',
      textAlign: 'left',
    },

    '& > .font-error': {
      '-ms-grid-row': '4',
    },

    '& > #FinalUrlSuffixErrors': {
      '-ms-grid-row': '5',
    },

    '& > span.control-label': {
      '-ms-grid-row': '6',
    },

    '& > :last-child': {
      '-ms-grid-row': '7',
    },
  },

  ...uurlTestToolStyle({ palette, iconFontFamily }),

  '& .error, & .font-error': {
    color: '#A80000',
    fontSize: 12,
  },

  '& div.error': {
    margin: '4px 0 0 0',
  },

  '& input.error, & input.validation-error': {
    border: '1px solid #A80000',
    margin: 'unset',
  },

  '& .container-fluid': {
    display: 'grid',
    fallbacks: [
      {
        display: '-ms-grid',
      },
    ],
    gridTemplateColumns: 'auto 1fr',
    '-ms-grid-columns': 'auto 1fr',
    paddingLeft: 0,
    paddingRight: 0,
    width: '100%',

    '& > span': {
      display: 'block',
    },
  },

  '& ol, & ul': {
    margin: 0,
  },

  '& .url, & .final-url, & .mobile-url': {
    '& .flex-row-fixed': {
      gridColumnStart: '1',
      '-ms-grid-column': '1',
      '-ms-grid-row': '1',
      marginRight: 6,
    },

    '& .flex-row-dynamic': {
      gridColumnStart: '2',
      '-ms-grid-column': '2',
      '-ms-grid-row': '1',
      marginLeft: 6,

      '& + .error': {
        gridColumnStart: '1',
        gridColumnEnd: 'span 2',
        '-ms-grid-column': '1',
        '-ms-grid-column-span': '2',
        '-ms-grid-row': '2',
      },
    },
  },

  '& .display-url': {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'baseline',

    '& .ext__displayUrl__domain': {
      width: 'auto',
    },

    '& .ext__displayUrl__domain--placeholder': {
      color: palette.neutralSecondary,
    },

    '& .ext__displayUrl__path': {
      flex: '1 0 auto',
      width: '20%',
    },

    '& .ext__displayUrl__separator': {
      marginLeft: 6,
      marginRight: 6,
      width: 'auto',
    },

    '& .clearfix': {
      width: '100%',
    },
  },

  '& .upgraded-url': {
    marginTop: 32,

    '& .upgraded-url__container > div > .fieldRowAd': {
      '& > div:not([style="display: none;"]) ~ div': {
        marginTop: 8,
      },

      '& > .form-group[data-bind="visible: mobileUrlVisible"]': {
        marginTop: 32,
      },
    },
  },

  '& .custom-parameters, & .custom-paramters__container': {
    '& .custom-params-template .custom-param-entry': {
      display: 'flex',
      alignItems: 'baseline',

      '& .custom-param__key-container, & .flex-row-dynamic, & td': {
        display: 'flex',
        alignItems: 'baseline',
      },
    },

    '& .control-label': {
      whiteSpace: 'pre',
    },

    '& .custom-param__close-button': {
      marginLeft: 10,
      cursor: 'pointer',
    },
  },

  '& .advanced-options': {
    marginTop: 32,

    '& .title-container + .form-control-static': {
      padding: 0,
      minHeight: 'unset',
    },

    '& .expandable': {
      marginTop: 32,

      '& .form-group': {
        display: 'block',

        '& .title-container': {
          textAlign: 'left',
          paddingBottom: 8,

          '& + .form-control-static': {
            padding: 0,
          },
        },

        '& .tracking-template, & .final-url-suffix > div': {
          '& > .charactersRemaining': {
            textAlign: 'left',
          },

          '& .control-label': {
            fontWeight: 'normal',
            padding: 0,
          },
        },

        '& .custom-params-template .form-inline': {
          display: 'flex',
          fontWeight: 'normal',
          padding: 0,

          '& .control-label': {
            fontWeight: 'normal',
          },
        },

        '& .custom-params-template > div > span.control-label': {
          fontWeight: 'normal',
        },
      },
    },
  },

  '& div[data-type="DynamicSearch"]': {
    '& .form-control-static': {
      padding: 0,
      minHeight: 'unset',
    },
  },

  '& .col-sm-4.adgroup-selector': {
    width: '40%',

    '& .dropdown-toggle': {
      width: '100%',

      '& .selected-item': {
        maxWidth: '93%', // Leave some space to render edit icon.

        '& .selected-item': {
          maxWidth: '100%', // Fix bug: https://msasg.visualstudio.com/Bing_Ads/_queries/edit/2857432/
        },
      },
    },
  },

  ...crudAppInstallAdStyle({ palette, iconFontFamily }),
  ...crudRSAStyle({ palette, iconFontFamily }),
});

export const crudAudienceAdStyle = ({ palette = {} as CommonStylesPalette, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  ...underlineLinkStyle({ palette, elementLocator: ' > a.HelpTopic' }),

  '& .text-audience-ad': {
    paddingBottom: 20,
  },

  '& .form-group, & .image-section-label, & .custom-param__key-container': {
    '& label': {
      display: 'inline-block',
      padding: '0 0 8px 0',
    },

    '& a.helpbutton': {
      display: 'inline-block',
    },

    '& .input-group': {
      width: '100%',
    },
  },

  '& .btn-hero': {
    background: `${palette.white} !important`,
    border: `1px solid ${palette.neutralSecondaryAlt}`,
    borderRadius: 2,
    boxSizing: 'border-box',
    fontWeight: 600,

    '&:before': {
      color: palette.themePrimary,
      content: '"\\E710"',
      fontFamily: iconFontFamily,
      fontWeight: 'normal',
      marginRight: 8,
    },
  },

  '& .react-image-experience': {
    marginTop: 32,

    '& .crud-audience-ad-react .ad-edit-and-preview-container': {
      marginTop: 32,

      '& .collapsible-panel': {
        marginLeft: 0,
        marginTop: 12,

        '& .collapsible-heading': {
          border: 'none',

          '& .collapsible-title': {
            fontSize: '16px',
            lineHeight: '24px',

            '& > a': {
              color: 'rgb(0, 120, 212)',
            },
          },
        },

        '& .collapsible-collapse': {
          '& .image-experience-content': {
            minWidth: '100%',
          },
        },
      },

      '& > .col-sm-7': {
        marginLeft: '8%',
      },

      '& .ad-edit-with-image-container': {
        margin: 0,
        padding: 0,

        '& .ad-creation-content': {
          padding: 0,

          '& .ad-properties-section': {
            width: '100%',
          },
        },
      },
      ...getCrudAdImagePreviewStyles(null, { palette, iconFontFamily }),
    },
  },

  '& .audience-ads-policy-container': {
    marginTop: 32,
  },

  '& .image-experience-content .upload-progress-container': {
    paddingTop: 4,
    '& .bar-upload-progress-text': {
      marginTop: -10,
    },
  },

  '& .image-experience-content .image-list-view-content': {
    '& .image-list': {
      '& .image-list-label': {
        fontSize: 14,
        fontWeight: 600,
        lineHeight: '19px',
      },

      '& .image-list-content': {
        display: 'flex',
        border: '1px solid #C8C8C8',
        margin: '8px 0 0 0',
        padding: '16px 16px 12px 16px',
        width: 'fit-content',

        '& .image-list-item': {
          float: 'none',
          padding: 0,

          '& .image-list-item-video': {
            backgroundColor: 'rgb(97, 97, 97)',
          },

          '& ~ .image-list-item': {
            marginLeft: 8,
          },

          '& .dropdown.btn-group': {
            display: 'block',

            '&.image-edit-dropdown .dropdown-toggle': {
              extend: floatButtonStyle({ palette }).floatButton,
              fontFamily: iconFontFamily,
              fontSize: 16,
              lineHeight: 1,
              float: 'right',
              margin: 0,

              '&:before': {
                content: '"\\E70F"',
              },
            },

            '& .caret': {
              display: 'none',
            },
          },

          '& .image-item-ratio-label': {
            fontSize: 14,
            lineHeight: '20px',
          },
        },

        '& .remove-all-button': {
          background: 'none',
          border: 'none',
          color: palette.neutralSecondary,
          fontFamily: iconFontFamily,
          fontSize: 12,
          lineHeight: 1,
          margin: '-14px -14px 0 0',
          padding: 8,
          width: 28,
          height: 28,

          '&:before': {
            content: '"\\E711"',
          },
        },
      },
    },
  },

  '& .created-ad-list-container': {
    display: 'block',

    '& .ad-list-item': {
      backgroundColor: `${palette.white} !important`,
      border: `1px solid ${palette.neutralSecondary} !important`,
      margin: '20px 40px 20px 0 !important',

      '& .create-another-ad': {
        color: `${palette.themePrimary} !important`,
      },

      '& .existing-ad-options': {
        backgroundColor: 'transparent !important',
        height: 'auto !important',

        '& button': {
          color: `${palette.themePrimary} !important`,
        },
      },
      '& .unavailable-hint': {
        paddingTop: 36,
      },
    },
    '& .ad-list-video-item': {
      '&:before': {
        content: '"\\E072"',
        position: 'absolute',
        fontFamily: 'Glyphicons Halflings',
        color: 'white',
        left: 100,
        top: 42,
        fontSize: 24,
      },
    },
  },

  '& .recommend-title': {
    fontWeight: 600,
    fontSize: 20,
  },

  '& .ad-recommend-save-errors': {
    color: 'red',
  },

  '& .ad-recommend-list-container': {
    display: 'flex',
    minHeight: 140,

    '& .recommend-ad': {
      width: 360,
      height: 100,
      color: 'gray',
      position: 'relative',
      overflow: 'hidden',
      padding: 10,
      boxSizing: 'content-box',
      backgroundColor: `${palette.white}`,
      border: `1px solid ${palette.neutralSecondary}`,
      margin: '20px 40px 20px 0',
      display: 'flex',

      '& img': {
        width: 191,
        height: 100,
        marginRight: 10,
      },

      '& .text-wrapper': {
        overflow: 'hidden',
      },

      '& .ad-options': {
        position: 'absolute',
        width: '100%',
        height: 'auto',
        bottom: '0',
        left: '0',
        textIndent: 5,
        color: 'white',
        backgroundColor: 'transparent',
        paddingRight: 5,

        '& button': {
          cursor: 'pointer',
          width: 'min-content',
          float: 'right',
          border: 'none',
          color: '#0078d4',
          backgroundColor: 'unset',
          padding: '2px 5px',
          fontSize: 12,
        },
      },

      '& p': {
        overflow: 'hidden',
        fontSize: 12,
        textAlign: 'left',
        lineHeight: '15px',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
      },
    },
  },

  '& .react-image-experience .crud-audience-ad-react.crud-multimedia-ad-react': {
    marginTop: -32,

    '& .call-to-action-section': {
      '& .action-text, .action-language': {

        '& .dropdown-search-selector__dropdown': {
          marginLeft: 0,

          '& button.dropdown-toggle': {
            padding: 0,
            width: 'fit-content',
            minWidth: '100%',
            borderColor: palette.neutralSecondary,
            borderRadius: 2,
            fontWeight: 'normal',
          },

          '& .text-left': {
            padding: '4px 0px 0px 8px',
            marginRight: 25,
          },

          '& .glyphicon.glyphicon-chevron-down': {
            paddingTop: 7,
            marginRight: 5,
            fontSize: 14,
            color: palette.neutralSecondary,
          },
        },

        '& .dropdown-menu': {
          transform: 'translateY(0px)',
          transition: 'none',

          '& .dropdown-search-selector__search': {
            padding: '5px 0px',

            '& button': {
              // marginTop: 0,
            },

            '& input': {
              width: '80%',
            },
          },

          '& .dropdown-search-selector__options': {
            '& li>a': {
              color: '#333',
              display: 'block',
              padding: '5px 10px',
            },
          },
        },
      },
    },

    '& .ad-iamge-container': experienceContent({ palette, iconFontFamily }),

    '& .ad-edit-and-preview-container': {
      '& .col-sm-5': {
        width: '40%',
        minWidth: '40%',
      },

      '& .ad-edit-with-image-container .ad-creation-content .ad-properties-section': {
        marginTop: 0,

        '& .short-headline, .long-headline, .description': {
          marginTop: 12,
        },

        '& .image-manager-container, .image-required-error': {
          marginBottom: 0,
        },
      },

      ...experienceContent({ palette, iconFontFamily }),

      '& .new-preview-carousel-container': getMMAPreviewStyles(),
    },
  },
  '& .disclaimer-pinned': {
    position: 'relative',
  },
  '& .disclaimer-placeholder': {
    position: 'absolute',
    top: '20px',
    left: 0,
    maxHeight: '680.453px',
    borderRadius: '2px',
    boxShadow: 'rgba(0, 0, 0, 0.133) 0px 6.4px 14.4px 0px, rgba(0, 0, 0, 0.11) 0px 1.2px 3.6px 0px',
    outline: 'transparent',
    backgroundColor: 'white',
    width: '250px',
    padding: '15px',
  },
  '& .preview-ad__url': {
    display: 'flex',
    alignItems: 'center',
  },
  ...reactUIBlockerStyle(palette, 'rgba(255, 255, 255, 0.4)'),
  ...modalContainerStyle(palette),
});
